// frontend/src/utils/jobTitles.js - Professional job titles and display shortcuts.
// Keys match users.job_title values; keep in sync with backend/utils/jobTitles.js.

export const JOB_TITLES = [
  { key: 'engineer',   label: 'Engineer',   shortcut: 'Eng.' },
  { key: 'doctor',     label: 'Doctor',     shortcut: 'Dr.' },
  { key: 'professor',  label: 'Professor',  shortcut: 'Prof.' },
  { key: 'architect',  label: 'Architect',  shortcut: 'Arch.' },
  { key: 'accountant', label: 'Accountant', shortcut: 'Acc.' },
  { key: 'lawyer',     label: 'Lawyer',     shortcut: 'Adv.' },
  { key: 'pharmacist', label: 'Pharmacist', shortcut: 'Ph.' },
  { key: 'technician', label: 'Technician', shortcut: 'Tech.' },
  { key: 'consultant', label: 'Consultant', shortcut: 'Cons.' },
];

export function getJobTitleShortcut(key) {
  if (!key) return null;
  return JOB_TITLES.find(t => t.key === String(key).toLowerCase())?.shortcut || null;
}

// "Eng. Khaled" when a job title is set, plain name otherwise.
export function formatNameWithTitle(name, jobTitleKey) {
  if (!name) return name;
  const shortcut = getJobTitleShortcut(jobTitleKey);
  return shortcut ? `${shortcut} ${name}` : name;
}
